import { createContext } from 'react'
import type { ColorScheme } from '../telegram/types'

export type ThemeMode = 'auto' | 'light' | 'dark'

export const THEME_STORAGE_KEY = 'brainhone.theme'

export interface ThemeContextValue {
  mode: ThemeMode
  resolved: ColorScheme
  setMode: (mode: ThemeMode) => void
}

export const ThemeContext = createContext<ThemeContextValue | null>(null)
